var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaiLicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z",
    fill: "#F70042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0947 27.42L42.4103 11.1079C42.1323 10.6823 41.5329 10.5086 41.0378 10.9255L17.2888 30.6078C16.924 30.877 16.8284 31.4242 17.1064 31.789L27.8864 48.1012C28.2165 48.5963 28.894 48.5442 29.1633 48.2836L52.9123 28.6013C53.2771 28.3321 53.364 27.7848 53.0947 27.42ZM40.3168 13.9048L37.0159 32.6142L20.1206 30.5991L40.3168 13.9048ZM28.7985 46.1903L19.7558 32.4057L37.7456 34.6206H37.8411C38.206 34.6206 38.6664 34.2558 38.7532 33.7086L42.1844 13.9916L51.175 27.698L28.7985 46.1903Z",
    fill: "#0E0A18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3159 37.7128L10.687 42.3685L11.851 43.7669L17.4799 39.1199L16.3159 37.7128Z",
    fill: "#0E0A18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1574 42.4206L12.5373 47.0675L13.7013 48.4747L19.3214 43.819L18.1574 42.4206Z",
    fill: "#0E0A18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4396 51.8448L15.6036 53.2519L21.2325 48.5963L20.0598 47.1978L14.4396 51.8448Z",
    fill: "#0E0A18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiLicon);
export default __webpack_public_path__ + "static/media/MAILicon.11593ffd06a36ec42b38fa9c45eca0ce.svg";
export { ForwardRef as ReactComponent };